import{LOCAL_STORAGE_PDF_REPORT_VIEW_KEY as t}from"./constants.js";var a=JSON.parse(localStorage.getItem(t)||"false");export{a as isPDFReportView};
